import { render, staticRenderFns } from "./repartition-doughnut-quarter-arc.vue?vue&type=template&id=db58d256&scoped=true"
import script from "./repartition-doughnut-quarter-arc.vue?vue&type=script&lang=js"
export * from "./repartition-doughnut-quarter-arc.vue?vue&type=script&lang=js"
import style0 from "./repartition-doughnut-quarter-arc.vue?vue&type=style&index=0&id=db58d256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db58d256",
  null
  
)

export default component.exports